import React from "react";
import { SPECIES_SAVE } from "../../../../enums/ApiPaths";
import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import useSingleSpecies from "../hooks/useSingleSpecies";
import { SPECIES_MASTER } from "../../../../enums/QueryKeys";
import usePut from "../../../../hooks/usePut";
import { Controller, useForm } from "react-hook-form";

export default function BreedSelector({ id }) {
  const { t } = useTranslation();
  const { species: pet } = useSingleSpecies(id);
  const submittion = usePut(SPECIES_SAVE, SPECIES_MASTER);
  const {
      control,
      getValues,
    } = useForm();
  function handleSubmit(e) {
    e.preventDefault();
    const obj = parseSubmitData();
    submittion.submitCallback(obj);
  }

  function parseSubmitData() {
    var obj = {
      ...pet,
      breed: getValues("breed")
    };

    return obj;
  }

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={2}>
        <Grid container gap={1}>
        <Controller
            name={"breed"}
            control={control}
            label={t("breed")}
            defaultValue={pet?.breed ?? "noBreed"}
            render={({ field }) => (
            <FormControl fullWidth>
                <InputLabel>{t("breed")}</InputLabel>
                <Select
                    {...field}
                    fullWidth
                    label={t("breed")}
                    onChange={(event) => field.onChange(event.target.value)}
                >
                    <MenuItem key={"noBreed"} value={"noBreed"}>
                        {t("noBreed")}
                    </MenuItem>
                    <MenuItem key={"dogBreeds"} value={"dogBreeds"}>
                        {t("dogBreeds")}
                    </MenuItem>
                    <MenuItem key={"catBreeds"} value={"catBreeds"}>
                        {t("catBreeds")}
                    </MenuItem>
                </Select>
                </FormControl>
                )}
                />
        </Grid>
        <Box>
          <Button variant="contained" color="info" type="submit">
            {t("Save")}
          </Button>
        </Box>
      </Stack>
    </form>
  );
}
